import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/ScrollerItem.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/SearchBar.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "picker": "",
      "picker-value": _vm.typeName,
      "picker-list": _vm.typeList,
      "height": 5,
      "placeholder": i18n.tc("401")
    },
    on: {
      "on-ok": function (keyword, pickerCurrValue) {
        ;
        _vm.type = pickerCurrValue, _vm.refresh();
      }
    },
    model: {
      value: _vm.keyword,
      callback: function ($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c(__unplugin_components_1, {
    ref: "serviceGroupList",
    attrs: {
      "is-px": "",
      "height": _vm.scrollerHight
    },
    on: {
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c(__unplugin_components_2, {
      key: item.index,
      attrs: {
        "img-url": item.avatar,
        "name": item.name
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.onClick(index);
        }
      }
    }, [_c('div', {
      staticClass: "slot-title",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('div', {
      staticClass: "name smy__text-overflow-one-line"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      staticClass: "slot-title-type"
    }, [_vm._v(" " + _vm._s(_vm.getTypeName(item.type)) + " ")])]), _c('div', {
      staticClass: "label",
      attrs: {
        "slot": "extra"
      },
      slot: "extra"
    }, [_vm._v(_vm._s(item.revised_addr))]), _c('div', {
      staticClass: "label",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(_vm._s(item.revised_linkman) + ":" + _vm._s(item.revised_linkman_phone))])]);
  }), 1)], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };